import '@/assets/css/app.scss';
import orphansDirective from '@/directives/orphans';
import '@/plugins/sentry';
import router from '@/router/index';
import store from '@/store/index';
import { i18n } from '@/translation/i18n';
import '@/plugins/veevalidate';
import 'core-js/stable';
import { createApp, h } from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import { createPinia } from 'pinia';
import { gtm } from '@/plugins/gtm';

const pinia = createPinia();

const app = createApp(
    {
        render: () => h(App)
    }
);

app.use(vuetify);
app.use(store);
app.use(pinia);
app.use(router);
app.use(i18n);
app.use(gtm(router));
app.directive('orphans', orphansDirective);

app.config.performance = process.env.VUE_APP_DEVTOOLS === 'true';

app.mount('#app');
